var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphHero2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1575px",
    height: "667px",
    viewBox: "0 0 1575 667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.5902324%",
    y1: "103.31919%",
    x2: "50.5902324%",
    y2: "62.9052149%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80C3F3",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A90E2",
    stopOpacity: 0.0884001359,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Why-Meetworkplace?",
    transform: "translate(0.000000, -757.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(-1.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,465.487893 L127.064812,604.512127 L222.369158,516.121916 L274.496718,588.668106 L408.267464,588.668106 L486.578915,465.487893 L559.354879,535.00001 L687.537919,535.00001 L789.79453,516.121916 L831.763421,516.121916 L985.284361,604.512127 L1117.24824,535.00001 L1238.03671,516.121916 L1322.27008,385.776905 L1391.83964,447.649008 L1577.29453,352",
    id: "Path-5",
    stroke: "#CEE4FF",
    strokeWidth: 5,
    strokeDasharray: "20,15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.5,312 L1105.5,645.5",
    id: "Line-17",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.25,167 L872.25,645.5",
    id: "Line-17-Copy-4",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.25,386.5 L678.25,646.5",
    id: "Line-17-Copy",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,472.5 L108.25,646.5",
    id: "Line-17-Copy-3",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    stroke: "#4A90E2",
    strokeWidth: 8,
    fill: "url(#linearGradient-1)",
    points: "17.8566154 524.253344 111.20444 570.563423 164.514701 547.408383 281.220383 570.563423 326.776044 524.253344 679.411768 459.81194 733.349662 478.732672 776.741341 445.375351 873.762775 244.379996 912.009298 254.941929 982.093102 400.735254 1109.40566 378.838309 1218.40982 305.474143 1405.75092 305.474143 1555.62903 168.82718 1578 647.365165 2 647.365165 2 507.184676"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFFFFF",
    x: 0,
    y: 624,
    width: 1577,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-33-Copy",
    fill: "#FFFFFF",
    x: 1552,
    y: 0,
    width: 25,
    height: 639
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-33",
    fill: "#FFFFFF",
    x: 0,
    y: 435,
    width: 25,
    height: 204
  })), /*#__PURE__*/React.createElement("text", {
    id: 2021,
    fontFamily: "Helvetica",
    fontSize: 24,
    fontWeight: "normal",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1040,
    y: 322
  }, "2021")), /*#__PURE__*/React.createElement("text", {
    id: 2020,
    fontFamily: "Helvetica",
    fontSize: 24,
    fontWeight: "normal",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 789,
    y: 183
  }, "2020")), /*#__PURE__*/React.createElement("text", {
    id: 2019,
    fontFamily: "Helvetica",
    fontSize: 24,
    fontWeight: "normal",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 613,
    y: 408
  }, "2019")), /*#__PURE__*/React.createElement("text", {
    id: 2010,
    fontFamily: "Helvetica",
    fontSize: 24,
    fontWeight: "normal",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 118,
    y: 489
  }, "2010")), /*#__PURE__*/React.createElement("text", {
    id: "45.1%",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 612,
    y: 368
  }, "45.1%")), /*#__PURE__*/React.createElement("text", {
    id: "30.4%",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 116,
    y: 457
  }, "30.4%")), /*#__PURE__*/React.createElement("text", {
    id: "57.3%",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 789,
    y: 150
  }, "57.3%")), /*#__PURE__*/React.createElement("text", {
    id: "47.2%",
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1037,
    y: 283
  }, "47.2%")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphHero2);
export default __webpack_public_path__ + "static/media/graph-hero2.481592176551d68635c769911b56445a.svg";
export { ForwardRef as ReactComponent };